import { News } from '@/types/community/news';

export const newsItems: News[] = [
  {
    id: 'NEWS001',
    title: 'Renovación de la Piscina Comunitaria',
    description: 'La piscina comunitaria se someterá a renovación del 15 de marzo al 15 de abril. Durante este tiempo, la piscina estará cerrada por mantenimiento y mejoras.',
    category: 'general',
    status: 'published',
    author: {
      id: 'EMP001',
      name: 'Gerente de Comunidad',
      type: 'employee',
      profilePicture: {
        id: 'PROF001',
        name: 'community_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP001/community_manager.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-01T10:00:00'),
    expiryDate: new Date('2024-04-15T23:59:59'),
    liked: {
      count: 12,
      users: [
        { id: 'RES001', name: 'Juan Smith' },
        { id: 'RES002', name: 'Jane Smith' }
      ]
    },
    comments: [
      {
        content: '¡Excelentes noticias! La piscina realmente necesita renovación.',
        author: { id: 'RES001', name: 'Juan Smith', type: 'resident' },
        createdAt: new Date('2024-03-01T11:00:00')
      }
    ],
    photos: [
      {
        id: 'PHOTO001',
        name: 'pool_renovation.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS001/pool_renovation.jpg',
        url: 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-01T10:00:00')
      }
    ],
    attachments: [
      {
        id: 'ATT001',
        name: 'pool_renovation_plan.pdf',
        type: 'application/pdf',
        size: 2048,
        path: '/documents/news/NEWS001/pool_renovation_plan.pdf',
        url: 'https://example.com/docs/pool_renovation.pdf',
        uploadedAt: new Date('2024-03-01T10:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS002',
    title: 'Apertura del Nuevo Centro de Fitness',
    description: 'Nos complace anunciar la apertura de nuestro nuevo centro de fitness de última generación. Las instalaciones incluyen equipos modernos y estarán abiertas 24/7.',
    category: 'general',
    status: 'published',
    author: {
      id: 'EMP001',
      name: 'Gerente de Comunidad',
      type: 'employee',
      profilePicture: {
        id: 'PROF001',
        name: 'community_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP001/community_manager.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-05T14:00:00'),
    expiryDate: new Date('2024-04-05T23:59:59'),
    liked: {
      count: 8,
      users: [
        { id: 'RES003', name: 'Mike Johnson' },
        { id: 'RES004', name: 'Sarah Wilson' }
      ]
    },
    comments: [],
    photos: [
      {
        id: 'PHOTO002',
        name: 'fitness_center.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS002/fitness_center.jpg',
        url: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-05T14:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS003',
    title: 'Reunión Mensual de la Comunidad',
    description: 'Únase a nosotros para nuestra reunión mensual de la comunidad el 20 de marzo a las 7 PM en la casa club. Discutiremos proyectos futuros y abordaremos las preocupaciones de los residentes.',
    category: 'general',
    status: 'published',
    author: {
      id: 'EMP002',
      name: 'Gerente Asistente',
      type: 'employee',
      profilePicture: {
        id: 'PROF002',
        name: 'assistant_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP002/assistant_manager.jpg',
        url: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-10T09:00:00'),
    expiryDate: new Date('2024-03-21T23:59:59'),
    liked: {
      count: 15,
      users: [
        { id: 'RES005', name: 'David Brown' },
        { id: 'RES006', name: 'Amanda Martinez' }
      ]
    },
    comments: [
      {
        content: '¡Estaré allí! Tenemos algunos problemas importantes que discutir.',
        author: { id: 'RES005', name: 'David Brown', type: 'resident' },
        createdAt: new Date('2024-03-10T10:00:00')
      }
    ],
    photos: [
      {
        id: 'PHOTO003',
        name: 'community_meeting.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS003/community_meeting.jpg',
        url: 'https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-10T09:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS004',
    title: 'Actualización de la Política de Estacionamiento',
    description: 'Las políticas de estacionamiento actualizadas serán efectivas a partir del 1 de abril. Por favor revise las nuevas pautas y asegúrese de cumplir.',
    category: 'general',
    status: 'published',
    author: {
      id: 'EMP001',
      name: 'Gerente de Comunidad',
      type: 'employee',
      profilePicture: {
        id: 'PROF001',
        name: 'community_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP001/community_manager.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-12T11:00:00'),
    expiryDate: new Date('2024-04-12T23:59:59'),
    photos: [
      {
        id: 'PHOTO004',
        name: 'parking_policy.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS004/parking_policy.jpg',
        url: 'https://images.unsplash.com/photo-1549924231-f129b911e442?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-12T11:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS005',
    title: 'Horario de Limpieza de Primavera',
    description: 'El horario de limpieza de primavera para las áreas comunes ha sido publicado. Por favor revise el tablero de avisos para las fechas asignadas de su bloque.',
    category: 'general',
    status: 'published',
    author: {
      id: 'EMP003',
      name: 'Supervisor de Mantenimiento',
      type: 'employee',
      profilePicture: {
        id: 'PROF003',
        name: 'maintenance_supervisor.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP003/maintenance_supervisor.jpg',
        url: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-15T08:00:00'),
    expiryDate: new Date('2024-04-15T23:59:59'),
    photos: [
      {
        id: 'PHOTO005',
        name: 'spring_cleaning.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS005/spring_cleaning.jpg',
        url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-15T08:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS006',
    title: 'Actualización del Sistema de Seguridad',
    description: 'Estamos actualizando nuestro sistema de seguridad para mejorar la seguridad de los residentes. La instalación comenzará la próxima semana y puede causar interrupciones temporales.',
    category: 'general',
    status: 'published',
    author: {
      id: 'EMP001',
      name: 'Gerente de Comunidad',
      type: 'employee',
      profilePicture: {
        id: 'PROF001',
        name: 'community_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP001/community_manager.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-18T16:00:00'),
    expiryDate: new Date('2024-04-18T23:59:59'),
    photos: [
      {
        id: 'PHOTO006',
        name: 'security_system.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS006/security_system.jpg',
        url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-18T16:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS007',
    title: 'Apertura del Jardín Comunitario',
    description: '¡Nuestro nuevo jardín comunitario ya está abierto! Los residentes pueden reservar parcelas para jardinería. Contacte a la oficina para registrarse.',
    category: 'general',
    status: 'published',
    author: {
      id: 'EMP002',
      name: 'Gerente Asistente',
      type: 'employee',
      profilePicture: {
        id: 'PROF002',
        name: 'assistant_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP002/assistant_manager.jpg',
        url: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-20T10:00:00'),
    expiryDate: new Date('2024-04-20T23:59:59'),
    photos: [
      {
        id: 'PHOTO007',
        name: 'community_garden.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS007/community_garden.jpg',
        url: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-20T10:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS008',
    title: 'Mantenimiento del Servicio de Internet',
    description: 'El mantenimiento programado para los servicios de internet se llevará a cabo el 25 de marzo de 2 AM a 4 AM. Pueden ocurrir interrupciones del servicio.',
    category: 'general',
    status: 'published',
    author: {
      id: 'EMP003',
      name: 'Supervisor de Mantenimiento',
      type: 'employee',
      profilePicture: {
        id: 'PROF003',
        name: 'maintenance_supervisor.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP003/maintenance_supervisor.jpg',
        url: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-22T12:00:00'),
    expiryDate: new Date('2024-03-26T23:59:59'),
    photos: [
      {
        id: 'PHOTO008',
        name: 'internet_maintenance.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS008/internet_maintenance.jpg',
        url: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-22T12:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS009',
    title: 'Día de Apreciación del Residente',
    description: '¡Únase a nosotros para el Día de Apreciación del Residente el 30 de marzo! Comida gratis, juegos y entretenimiento para todos los residentes.',
    category: 'general',
    status: 'published',
    author: {
      id: 'EMP001',
      name: 'Gerente de Comunidad',
      type: 'employee',
      profilePicture: {
        id: 'PROF001',
        name: 'community_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP001/community_manager.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-25T15:00:00'),
    expiryDate: new Date('2024-03-31T23:59:59'),
    photos: [
      {
        id: 'PHOTO009',
        name: 'resident_appreciation.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS009/resident_appreciation.jpg',
        url: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-25T15:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS010',
    title: 'Información de Contacto de Emergencia',
    description: 'Por favor asegúrese de que su información de contacto de emergencia esté actualizada. Esto es crucial para su seguridad y nuestra capacidad de contactarlo en emergencias.',
    category: 'general',
    status: 'published',
    author: {
      id: 'EMP001',
      name: 'Gerente de Comunidad',
      type: 'employee',
      profilePicture: {
        id: 'PROF001',
        name: 'community_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP001/community_manager.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-28T09:00:00'),
    expiryDate: new Date('2024-04-28T23:59:59'),
    photos: [
      {
        id: 'PHOTO010',
        name: 'emergency_contact.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS010/emergency_contact.jpg',
        url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-28T09:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  }
]; 